export const commit = '9409e2324d60c6ac826a467dff98416e536a5467';
export const branch = '23.03-beta.420';
export const date = '2023-02-16 17:05:00 MSK';
export const version = branch.match(/release-(.*)/)?.[1] || branch;
